<template>
  <div class="custom-tree-container">
    <el-row class="custom-one">
      <el-row class="title">
        <el-col :span="6">所有模块</el-col>
        <el-col :span="18" class="title-right">
          <span>操作</span>
          <span>授权</span>
        </el-col>
      </el-row>
      <div class="block">
        <el-tree
          :data="authorityData"
          node-key="id"
          :default-expanded-keys="defaultKey"
          :expand-on-click-node="false"
          @node-expand="addNode"
          @node-collapse="delNode"
        >
          <span class="custom-tree-node is-show" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span>
              <span
                type="text"
                class="iconfont"
                :class="[data.operation == '2' ? 'icon-unlock' : 'icon-lock']"
                style="width: auto; margin-right: 68px"
                size="mini"
                @click="() => append(data)"
              ></span>
              <span
                type="text"
                class="iconfont"
                :class="[
                  data.authorization == '2' ? 'icon-unlock' : 'icon-lock',
                ]"
                style="width: auto; margin-right: 74px"
                size="mini"
                @click="() => remove(node, data)"
              ></span>
            </span>
          </span>
        </el-tree>
      </div>
    </el-row>
  </div>
</template>
<script>
// let id = 1000;

export default {
  name: "AuthorityTree",
  props: {
    authorityData: {
      type: Array,
      default: () => [],
      required: true,
    },
    keyArr: {
      type: Array,
      default: () => [],
      required: true,
    },
    isAuction: {
      type: Boolean,
      require: true,
    },
  },
  data() {
    return {
      defaultKey: [],
    };
  },
  //created() {
  //let _this = this
  // setTimeout模拟异步数据
  // setTimeout(() => {
  //_this.defaultKey = _this.keyArr
  // }, 1000)
  //},
  watch: {
    keyArr: {
      handler(val) {
        this.defaultKey = val;
      },
      deep: true,
    },
  },
  methods: {
    append(data) {
      let authority = {};
      if (data.operation == 1) {
        data.operation = 2;
        authority = {
          authorityId: data.id,
          authorization: data.authorization,
          operation: 2,
        };
      } else {
        data.operation = 1;
        data.authorization = 1;
        authority = {
          authorityId: data.id,
          authorization: 1,
          operation: 1,
        };
      }
      this.$emit("clickAuthority", authority, this.defaultKey);
    },

    remove(node, data) {
      let authority = {};
      if (data.authorization == 1) {
        data.authorization = 2;
        data.operation = 2;
        authority = {
          authorityId: data.id,
          authorization: 2,
          operation: 2,
        };
      } else {
        data.authorization = 1;
        authority = {
          authorityId: data.id,
          authorization: 1,
          operation: data.operation,
        };
      }
      this.$emit("clickAuthority", authority, this.defaultKey);
    },
    addNode(obj) {
      console.log(obj.id);
      this.defaultKey.push(obj.id);
    },
    delNode(obj) {
      let key = this.defaultKey.indexOf(obj.id);
      this.defaultKey.splice(key, 1);
    },
    mouseenter() {},
    mouseleave() {},
  },
};
</script>

<style lang="scss" scoped>
.title {
  width: 100%;
  height: 48px;
  line-height: 48px;
  padding: 0 10px 0 20px;
  margin-bottom: 12px;
  font-size: 14px;
  color: #333;
  background-color: #eee;
}
.title-right {
  display: inline-block;
  text-align: right;
}
.title-right span {
  margin-right: 68px;
}
//不能加，会破坏树形结构
// .block /deep/ .el-tree .el-tree-node__content {
//   padding: 0 10px 0 10px !important;
// }
.custom-tree-node {
  height: 26px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.icon-unlock {
  color: #0093ff;
  font-size: 18px;
}
.icon-lock {
  color: #333;
  font-size: 18px;
}
</style>
